'use strict';

import { action, observable, flow, runInAction, makeObservable } from "mobx";
import React from 'react';
import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import appStore from "@uw-it-sis/lib-react/lib/AppStore";
import {capitalize} from "@uw-it-sis/lib-react/lib/Utils";

class ImportSocialPlanConfirmStore {
    state = States.initial;

    social = {};

    constructor() {
        makeObservable(this, {
            state: observable,
            social: observable,
            mount: action
        });
        this.exceptionUtils = appStore.getExceptionUtils();
        this.httpClient = appStore.getHttpClient();
    }

    mount() {
        this._loadData();
        this.runImport = this.runImport.bind(this);
    }

    _loadData = flow(function* () {
        this.state = States.pending;

        // Build url for the ajax call
        let url = 'api/socialImport/info';

        try {
            this.social = yield this.httpClient.doGet(url, 'getSocialImportInfo');

            this.social.provider = capitalize(this.social.provider);

            if (appStore.isDevMode()) {
                console.log('ImportConfirmStore: Data load complete');
            }

            this.state = States.done;
        } catch(error) {
            this.exceptionUtils.handleException(error, "ImportSocialPlanConfirmStore.loadData");
            this.state = States.error;
        }
    })

    runImport = flow(function* () {
        // Set the state back to pending to show we're running
        this.state = States.pending;

        let url = "api/socialImport/run";

        try {
            const response = yield this.httpClient.doPut(url, null,'runSocialImportInfo');

            // Send the user back to their plan
            window.location.hash = '#/';

            this.state = States.done;
        } catch(error) {
            this.exceptionUtils.handleException(error, "ImportSocialPlanConfirmStore.runImport");
            this.state = States.error;
        }
    })
}

export default new ImportSocialPlanConfirmStore();
